import { defaultTipPrudence, defaultFilterTipsPrudenceSga } from "./state";

/**
 * Mutación que lista los consejos de prudencia de SGA.
 *
 * @param {*} state.tipsPrudenceSga - Estado de los consejos de prudencia de SGA.
 * @param tipsPrudenceSga - Consejos de prudencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setTipsPrudenceSga(state, tipsPrudenceSga) {
    state.tipsPrudenceSga = tipsPrudenceSga;
}

/**
 * Mutación que establece la acción a realizar (Crear o actualizar).
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar (create o edit).
 * @return {void}
 * @author Brandon Torres
 */
export function setActionTipPrudenceSga(state, action) {
    state.action = action;
}

/**
 * Mutación que establece el consejo de prudencia por defecto.
 *
 * @param {*} state.tipPrudence - Estado del consejo de prudencia.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultTipPrudenceSga(state) {
    state.tipPrudence = defaultTipPrudence();
}

/**
 * Mutación que establece el filtro de los consejos de prudencia de SGA por defecto.
 *
 * @param {*} state.filterTipsPrudenceSga - Estado del filtro de los consejos de prudencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterTipsPrudenceSga(state) {
    state.filterTipsPrudenceSga = defaultFilterTipsPrudenceSga();
}

/**
 * Mutación que establece la cantidad de consejos de prudencia por página.
 *
 * @param {*} state.filterTipsPrudenceSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterTipsPrudenceSga.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterTipsPrudenceSga = {
        ...state.filterTipsPrudenceSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param {*} state.filterTipsPrudenceSga.page - Página actual.
 * @param page - Cambio de página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterTipsPrudenceSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de los consejos de prudencia.
 *
 * @param {*} state.filterTipsPrudenceSga.page - Página actual.
 * @param {*} state.filterTipsPrudenceSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterTipsPrudenceSga.total - Total de registros.
 * @param paginate - Paginación de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateTipsPrudenceSga(state, paginate) {
    state.filterTipsPrudenceSga = {
        ...state.filterTipsPrudenceSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece el consejo de prudencia de SGA.
 *
 * @param {*} state.tipPrudence - Estado del consejo de prudencia.
 * @param tipPrudence - Consejo de prudencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setTipPrudenceSga(state, tipPrudence) {
    state.tipPrudence = {
        id: tipPrudence.id,
        name: tipPrudence.name,
        code: tipPrudence.code,
        prudence_tip_type_id: tipPrudence.prudence_tip_type_id,
        sga_prudence_tip_code_languages:
            tipPrudence.sga_prudence_tip_code_languages,
        parent_prudence_tip_codes: tipPrudence.parent_prudence_tip_codes,
    };
}

/**
 * Mutación que establece los consejos de prudencia activos de SGA.
 *
 * @param {*} state.activeTipsPrudenceSga - Estado de los consejos de prudencia activos de SGA.
 * @param activeTipsPrudenceSga - Consejos de prudencia activos de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActiveTipsPrudenceSga(state, activeTipsPrudenceSga) {
    state.activeTipsPrudenceSga = activeTipsPrudenceSga;
}
